import React from 'react'
import { Text } from 'native-base'
import type { StyleProp, TextStyle } from 'react-native'

const H3: React.FC<{
  style?: StyleProp<TextStyle>;
  testID?: string;
}> = ({ children, style, testID }) => {
  return (
    <Text
      testID={testID}
      fontSize="lg"
      fontWeight={700}
      fontFamily="Lato"
      color="dark"
      style={style}
    >
      {children}
    </Text>
  )
}

export default H3
